
























import Vue from 'vue'
import TrackingTableHeader from '@/UI/Tracking/TrackingTableHeader.vue'
import TrackingTableRow from '@/UI/Tracking/TrackingTableRow.vue'
import LumberJackTable from '@/UI/Tracking/LumberJack/LumberJackTable.vue'

export default Vue.extend({
  name: 'TrackingTable',
  components: { TrackingTableHeader, TrackingTableRow, LumberJackTable },
  props: {
    datosT: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      expandedRows: [] as number[]
    }
  },
  methods: {
    onBatchrowToggledExpanded (expanded: boolean, index: number) {
      if (expanded) {
        this.expandedRows.push(index)
        return
      }
      const updatedIndexes = this.expandedRows.filter(current => current !== index)
      this.expandedRows = updatedIndexes
    }
  }
})
